export default "/_next/static/media/hero-mob.9dc09a333be806c573d5b73560f387d9.webm";